/**
 * Constants used across FloorplanViewer components
 */

// Sensor types
export const SENSOR_TYPES = {
  OA: 'OA',
  WAFFLE: 'Waffle',
  ENTRY: 'Entry'
};

// Space types
export const SPACE_TYPES = {
  ROOM: 'room',
  DESK: 'desk',
  FLEX: 'flex',
  PHONE: 'phone',
  ENTRY: 'entry'
};

// Drawing modes
export const DRAWING_MODES = {
  NONE: 'none',
  MEASURING: 'measuring',
  DRAWING_BOX: 'drawing_box',
  DRAWING_SHAPE: 'drawing_shape',
  SETTING_SCALE: 'setting_scale',
  ADDING_ENTRY: 'adding_entry',
  SELECT_MODE: 'select_mode',
  CEILING_HEIGHT: 'ceiling_height'
};

// Zoom constants
export const ZOOM_CONSTANTS = {
  MIN_SCALE: 0.1,
  MAX_SCALE: 10,
  ZOOM_IN_FACTOR: 1.1,
  ZOOM_OUT_FACTOR: 0.9
};

// Waffle types - for differentiating between meeting room and desk waffles
export const WAFFLE_TYPES = {
  MEETING: 'meeting',
  DESK: 'desk'
};

// Default ceiling height in feet
export const DEFAULT_CEILING_HEIGHT = 9.0;

// Default sensor coverage in square feet
export const DEFAULT_SENSOR_COVERAGE = 200;

// Sensor colors
export const SENSOR_COLORS = {
  [SENSOR_TYPES.OA]: '#4CAF50',      // Green - for OA sensors
  [SENSOR_TYPES.WAFFLE]: '#4ecdc4',  // Teal - matches .waffle-type
  [SENSOR_TYPES.ENTRY]: '#9d65c9'    // Purple - matches .entry-type
};

// Space type colors - for color-coding different space types
export const SPACE_TYPE_COLORS = {
  [SPACE_TYPES.DESK]: '#E3AF43',    // Yellow
  [SPACE_TYPES.ROOM]: '#53B06C',    // Green
  [SPACE_TYPES.PHONE]: '#ff39c9',   // Hot Pink
  [SPACE_TYPES.FLEX]: '#9EB6F8',    // Blue
  [SPACE_TYPES.ENTRY]: '#7B2FDD',   // Purple
};

// Default space category visibility
export const SPACE_CATEGORY_VISIBILITY = {
  [SPACE_TYPES.DESK]: true,
  [SPACE_TYPES.ROOM]: true,
  [SPACE_TYPES.PHONE]: true,
  [SPACE_TYPES.FLEX]: true,
  [SPACE_TYPES.ENTRY]: true,
}; 